import { render, staticRenderFns } from "./ob-wenn.vue?vue&type=template&id=65b73136&scoped=true"
import script from "./ob-wenn.vue?vue&type=script&lang=js"
export * from "./ob-wenn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b73136",
  null
  
)

export default component.exports